module.exports = __webpack_public_path__ + "img/cxample_08.bf76f39c.png";